import React from 'react';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const GridwallSearchToolTip = () => (
  <ul className='mt2-sm prl5-sm'>
    <li>
      <TranslatedCopy id='gridwall.search.tooltip.tip1' />
    </li>
    <li>
      <TranslatedCopy id='gridwall.search.tooltip.tip2' />
    </li>
    <li>
      <TranslatedCopy id='gridwall.search.tooltip.tip3' />
    </li>
    <li>
      <TranslatedCopy id='gridwall.search.tooltip.tip4' />
    </li>
  </ul>
);

export default GridwallSearchToolTip;
